export const columnsToExport = [
  'feTipoCFETexto',
  'feSerieCFE',
  'feNroCFE',
  'fecha',
  'razonSocial',
  'rutCliente',
  'oidLiquidacionWeb',
  'clasificacionDocumento',
  'contenedor',
  'nombreViaje',
  'armador',
  'moneda',
  'importe',
];
